import React from 'react'
import { useSelector } from 'react-redux'
import {
  FormLabel,
  BasicDropdown,
  FormRow,
} from '../../../components'
import { useSystem } from '../../../features/system/hook'

const FormSystem = ({handleMulti}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  const {
    approachOptions,
    issueOptions,
    organizationTypeOptions,
    audienceOptions
  } = useSystem()

  return (
    <div>
      <div className="flex flex-wrap -mx-4">
        <div className="w-full md:w-6/12 px-4">
          <FormRow>
            <FormLabel>
              {translation.ORGANIZATION.type[language.name]}
            </FormLabel>
            <BasicDropdown
              multi
              placeholder={translation.ORGANIZATION.type_choose[language.name]}
              options={organizationTypeOptions}
              onChange={(e) => handleMulti(e, 'type')}
            />
          </FormRow>
        </div>
        <div className="w-full md:w-6/12 px-4">
          <FormRow>
            <FormLabel>
              {translation.ORGANIZATION.audience[language.name]}
            </FormLabel>
            <BasicDropdown
              multi
              placeholder={translation.ORGANIZATION.audience_choose[language.name]}
              options={audienceOptions}
              onChange={(e) => handleMulti(e, 'audience')}
            />
          </FormRow>
        </div>
      </div>

      <div className="flex flex-wrap -mx-4">
        <div className="w-full md:w-6/12 px-4">
          <FormRow>
            <FormLabel>
             {translation.ORGANIZATION.approach[language.name]}
            </FormLabel>
            <BasicDropdown
              multi
              placeholder={translation.ORGANIZATION.approach_choose[language.name]}
              options={approachOptions}
              onChange={(e) => handleMulti(e, 'approach')}
            />
          </FormRow>
        </div>
        <div className="w-full md:w-6/12 px-4">
          <FormRow>
            <FormLabel>
             {translation.ORGANIZATION.issue[language.name]}
            </FormLabel>
            <BasicDropdown
              multi
              placeholder={translation.ORGANIZATION.issue_choose[language.name]}
              options={issueOptions}
              onChange={(e) => handleMulti(e, 'issue')}
            />
          </FormRow>
        </div>
      </div>
    </div>
  )
}

export { FormSystem }
